/* eslint-disable */

import React, { useState, useEffect, useCallback } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import Chart from "react-apexcharts";

const filesList = [
    {
        "id": 1,
        "fileName": "logo-dark.png",
        "filetype": "Media",
        "fileItem": "01",
        "fileSize": "1.3 MB",
        "date": "24 May, 2022",
        "starred": false
    },
    {
        "id": 2,
        "fileName": "velzon-invoice.pdf",
        "filetype": "Documents",
        "fileItem": "01",
        "fileSize": "1.1 MB",
        "date": "05 May, 2022",
        "starred": true
    },
    {
        "id": 3,
        "fileName": "Velzon React",
        "filetype": "Media",
        "fileItem": "367",
        "fileSize": "934 MB",
        "date": "28 Apr, 2022",
        "starred": false
    },
    {
        "id": 4,
        "fileName": "html.docx",
        "filetype": "Documents",
        "fileItem": "01",
        "fileSize": "0.3 KB",
        "date": "19 Apr, 2022",
        "starred": false
    },
    {
        "id": 5,
        "fileName": "default.jpg",
        "filetype": "Media",
        "fileItem": "01",
        "fileSize": "1.7 MB",
        "date": "06 Apr, 2022",
        "starred": true
    }
];

import { ApexOptions } from "apexcharts";
import { getAuthCookie } from "../../utils/authCookies";

const chartOptions: ApexOptions = {
    chart: {
      type: 'donut',
    },
    labels: ['Documents', 'Media', 'Projects', 'Others'],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 300
        },
        legend: {
          position: 'bottom'
        }
      }
    }]
  };

  const chartSeries = [27.01, 20.87, 4.10, 33.54];

const SignageFileManager = () => {
    const editEvent = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault();
        // Add your event editing logic here
        console.log("Edit event clicked");
    };
    const [error, setError] = useState<string>("");
    const [loading, setLoading] = useState(true);
    const [deleting, setDeleting] = useState<string | null>(null);
    const token = getAuthCookie("sessionToken");
    const location = useLocation();
    const navigate = useNavigate();
    const [showCreateFileModal, setShowCreateFileModal] = useState(false);
    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);

    return (
        <div className="content">
            <div className="card">
                <div className="card-body">

                    <div className="chat-wrapper d-lg-flex gap-1 mx-n4 mt-n4 p-1">
                        <div className="file-manager-sidebar minimal-border">
                            <div className="p-3 d-flex flex-column h-100">
                                <div className="mb-3">
                                    <h5 className="mb-0 fw-semibold">My Drive</h5>
                                </div>
                                <div className="search-box">
                                    <input type="text" className="form-control bg-light border-light" placeholder="Search here..." />
                                    <i className="ri-search-2-line search-icon"></i>
                                </div>
                                <div className="mt-3 mx-n4 px-4 file-menu-sidebar-scroll" data-simplebar>
                                    <ul className="list-unstyled file-manager-menu">
                                        <li>
                                            <a data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="true" aria-controls="collapseExample">
                                                <i className="ri-folder-2-line align-bottom me-2"></i> <span className="file-list-link">My Drive</span>
                                            </a>
                                            <div className="collapse show" id="collapseExample">
                                                <ul className="sub-menu list-unstyled">
                                                    <li>
                                                        <a href="#!">Assets</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">Marketing</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">Personal</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">Projects</a>
                                                    </li>
                                                    <li>
                                                        <a href="#!">Templates</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </li>
                                        <li>
                                            <a href="#!"><i className="ri-file-list-2-line align-bottom me-2"></i> <span className="file-list-link">Documents</span></a>
                                        </li>
                                        <li>
                                            <a href="#!"><i className="ri-image-2-line align-bottom me-2"></i> <span className="file-list-link">Media</span></a>
                                        </li>
                                        <li>
                                            <a href="#!"><i className="ri-history-line align-bottom me-2"></i> <span className="file-list-link">Recent</span></a>
                                        </li>
                                        <li>
                                            <a href="#!"><i className="ri-star-line align-bottom me-2"></i> <span className="file-list-link">Important</span></a>
                                        </li>
                                        <li>
                                            <a href="#!"><i className="ri-delete-bin-line align-bottom me-2"></i> <span className="file-list-link">Deleted</span></a>
                                        </li>
                                    </ul>
                                </div>


                                <div className="mt-auto">
                                    <h6 className="fs-11 text-muted text-uppercase mb-3">Storage Status</h6>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-shrink-0">
                                            <i className="ri-database-2-line fs-17"></i>
                                        </div>
                                        <div className="flex-grow-1 ms-3 overflow-hidden">
                                            <div className="progress mb-2 progress-sm">
                                                <div className="progress-bar bg-success" role="progressbar" style={{ width: "25%" }} aria-valuenow={25} aria-valuemin={0} aria-valuemax={100}></div>
                                            </div>
                                            <span className="text-muted fs-12 d-block text-truncate"><b>47.52</b>GB used of <b>119</b>GB</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="file-manager-content minimal-border w-100 p-3 py-0">
                            <div className="mx-n3 pt-4 px-4 file-manager-content-scroll" data-simplebar>
                                <div id="folder-list" className="mb-2">
                                    <div className="row justify-content-beetwen g-2 mb-3">

                                        <div className="col">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-2 d-block d-lg-none">
                                                    <button type="button" className="btn btn-soft-success btn-icon btn-sm fs-16 file-menu-btn">
                                                        <i className="ri-menu-2-fill align-bottom"></i>
                                                    </button>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <h5 className="fs-16 mb-0">Folders</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-auto">
                                            <div className="d-flex gap-2 align-items-start">
                                                <select className="form-control" data-choices data-choices-search-false name="choices-single-default" id="file-type">
                                                    <option value="">File Type</option>
                                                    <option value="All" selected>All</option>
                                                    <option value="Video">Video</option>
                                                    <option value="Images">Images</option>
                                                    <option value="Music">Music</option>
                                                    <option value="Documents">Documents</option>
                                                </select>

                                                <button className="btn btn-success w-sm create-folder-modal flex-shrink-0" data-bs-toggle="modal" data-bs-target="#createFolderModal"><i className="ri-add-line align-bottom me-1"></i> Create Folders</button>
                                            </div>
                                        </div>

                                    </div>

                                    <div className="row" id="folderlist-data">
                                        <div className="col-xxl-3 col-6 folder-card">
                                            <div className="card bg-light shadow-none" id="folder-1">
                                                <div className="card-body">
                                                    <div className="d-flex mb-1">
                                                        <div className="form-check form-check-danger mb-3 fs-15 flex-grow-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="folderlistCheckbox_1" checked />
                                                            <label className="form-check-label" htmlFor="folderlistCheckbox_1"></label>
                                                        </div>
                                                        <div className="dropdown">
                                                            <button className="btn btn-ghost-primary btn-icon btn-sm dropdown material-shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ri-more-2-fill fs-16 align-bottom"></i>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><a className="dropdown-item view-item-btn" href="javascript:void(0);">Open</a></li>
                                                                <li><a className="dropdown-item edit-folder-list" href="#createFolderModal" data-bs-toggle="modal" role="button">Rename</a></li>
                                                                <li><a className="dropdown-item" href="#removeFolderModal" data-bs-toggle="modal" role="button">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="text-center">
                                                        <div className="mb-2">
                                                            <i className="ri-folder-2-fill align-bottom text-warning display-5"></i>
                                                        </div>
                                                        <h6 className="fs-15 folder-name">Projects</h6>
                                                    </div>
                                                    <div className="hstack mt-4 text-muted">
                                                        <span className="me-auto"><b>349</b> Files</span>
                                                        <span><b>4.10</b>GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-3 col-6 folder-card">
                                            <div className="card bg-light shadow-none" id="folder-2">
                                                <div className="card-body">
                                                    <div className="d-flex mb-1">
                                                        <div className="form-check form-check-danger mb-3 fs-15 flex-grow-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="folderlistCheckbox_2" />
                                                            <label className="form-check-label" htmlFor="folderlistCheckbox_2"></label>
                                                        </div>
                                                        <div className="dropdown">
                                                            <button className="btn btn-ghost-primary btn-icon btn-sm dropdown material-shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ri-more-2-fill fs-16 align-bottom"></i>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><a className="dropdown-item view-item-btn" href="javascript:void(0);">Open</a></li>
                                                                <li><a className="dropdown-item edit-folder-list" href="#createFolderModal" data-bs-toggle="modal" role="button">Rename</a></li>
                                                                <li><a className="dropdown-item" href="#removeFolderModal" data-bs-toggle="modal" role="button">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="text-center">
                                                        <div className="mb-2">
                                                            <i className="ri-folder-2-fill align-bottom text-warning display-5"></i>
                                                        </div>
                                                        <h6 className="fs-15 folder-name">Documents</h6>
                                                    </div>
                                                    <div className="hstack mt-4 text-muted">
                                                        <span className="me-auto"><b>2348</b> Files</span>
                                                        <span><b>27.01</b>GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-3 col-6 folder-card">
                                            <div className="card bg-light shadow-none" id="folder-3">
                                                <div className="card-body">
                                                    <div className="d-flex mb-1">
                                                        <div className="form-check form-check-danger mb-3 fs-15 flex-grow-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="folderlistCheckbox_3" />
                                                            <label className="form-check-label" htmlFor="folderlistCheckbox_3"></label>
                                                        </div>
                                                        <div className="dropdown">
                                                            <button className="btn btn-ghost-primary btn-icon btn-sm dropdown material-shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ri-more-2-fill fs-16 align-bottom"></i>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><a className="dropdown-item view-item-btn" href="javascript:void(0);">Open</a></li>
                                                                <li><a className="dropdown-item edit-folder-list" href="#createFolderModal" data-bs-toggle="modal" role="button">Rename</a></li>
                                                                <li><a className="dropdown-item" href="#removeFolderModal" data-bs-toggle="modal" role="button">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>

                                                    <div className="text-center">
                                                        <div className="mb-2">
                                                            <i className="ri-folder-2-fill align-bottom text-warning display-5"></i>
                                                        </div>
                                                        <h6 className="fs-15 folder-name">Media</h6>
                                                    </div>
                                                    <div className="hstack mt-4 text-muted">
                                                        <span className="me-auto"><b>12480</b> Files</span>
                                                        <span><b>20.87</b>GB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-xxl-3 col-6 folder-card">
                                            <div className="card bg-light shadow-none" id="folder-4">
                                                <div className="card-body">
                                                    <div className="d-flex mb-1">
                                                        <div className="form-check form-check-danger mb-3 fs-15 flex-grow-1">
                                                            <input className="form-check-input" type="checkbox" value="" id="folderlistCheckbox_4" checked />
                                                            <label className="form-check-label" htmlFor="folderlistCheckbox_4"></label>
                                                        </div>
                                                        <div className="dropdown">
                                                            <button className="btn btn-ghost-primary btn-icon btn-sm dropdown material-shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                <i className="ri-more-2-fill fs-16 align-bottom"></i>
                                                            </button>
                                                            <ul className="dropdown-menu dropdown-menu-end">
                                                                <li><a className="dropdown-item view-item-btn" href="javascript:void(0);">Open</a></li>
                                                                <li><a className="dropdown-item edit-folder-list" href="#createFolderModal" data-bs-toggle="modal" role="button">Rename</a></li>
                                                                <li><a className="dropdown-item" href="#removeFolderModal" data-bs-toggle="modal" role="button">Delete</a></li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <div className="text-center">
                                                        <div className="mb-2">
                                                            <i className="ri-folder-2-fill align-bottom text-warning display-5"></i>
                                                        </div>
                                                        <h6 className="fs-15 folder-name">Velzon v1.7.0</h6>
                                                    </div>
                                                    <div className="hstack mt-4 text-muted">
                                                        <span className="me-auto"><b>180</b> Files</span>
                                                        <span><b>478.65</b>MB</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                                <div>
                                    <div className="d-flex align-items-center mb-3">
                                        <h5 className="flex-grow-1 fs-16 mb-0" id="filetype-title">Recent File</h5>
                                        <div className="flex-shrink-0">
                                            <button className="btn btn-success createFile-modal" data-bs-toggle="modal" data-bs-target="#createFileModal"><i className="ri-add-line align-bottom me-1"></i> Create File</button>
                                        </div>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-active">
                                                <tr>
                                                    <th scope="col">Name</th>
                                                    <th scope="col">File Item</th>
                                                    <th scope="col">File Size</th>
                                                    <th scope="col">Recent Date</th>
                                                    <th scope="col" className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody id="file-list">
                                                {filesList?.map((file, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input className="form-control filelist-id" type="hidden" value="1" id="filelist-1" />
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                                                    <i className="ri-gallery-fill align-bottom text-success"></i>
                                                                </div>
                                                                <div className="flex-grow-1 filelist-name">{file?.fileName}</div>
                                                                <div className="d-none filelist-type">{file?.filetype}</div>
                                                            </div>
                                                        </td>
                                                        <td>{file?.fileItem}</td>
                                                        <td className="filelist-size">{file?.fileSize}</td>
                                                        <td className="filelist-create">{file?.date}</td>
                                                        <td>
                                                            <div className="d-flex gap-3 justify-content-center">
                                                                <button type="button" className="btn btn-ghost-primary btn-icon btn-sm material-shadow-none favourite-btn">
                                                                    <i className="ri-star-fill fs-13 align-bottom"></i> Create File 
                                                                </button>
                                                                <div className="dropdown">
                                                                    <button className="btn btn-light btn-icon btn-sm dropdown material-shadow-none" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        <i className="ri-more-fill align-bottom"></i>
                                                                    </button>
                                                                    <ul className="dropdown-menu dropdown-menu-end">
                                                                        <li><a className="dropdown-item viewfile-list" href="#">View</a></li>
                                                                        <li><a className="dropdown-item edit-list" href="#createFileModal" data-bs-toggle="modal" data-edit-id="1" role="button">Rename</a></li>
                                                                        <li className="dropdown-divider"></li>
                                                                        <li><a className="dropdown-item remove-list" href="#removeFileItemModal" data-id="1" data-bs-toggle="modal" role="button">Delete</a></li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <ul id="pagination" className="pagination pagination-lg"></ul>
                                    <div className="align-items-center mt-2 row g-3 text-center text-sm-start">
                                        <div className="col-sm">
                                            <div className="text-muted">Showing<span className="fw-semibold">4</span> of <span className="fw-semibold">125</span> Results
                                            </div>
                                        </div>
                                        <div className="col-sm-auto">
                                            <ul className="pagination pagination-separated pagination-sm justify-content-center justify-content-sm-start mb-0">
                                                <li className="page-item disabled">
                                                    <a href="#" className="page-link">←</a>
                                                </li>
                                                <li className="page-item">
                                                    <a href="#" className="page-link">1</a>
                                                </li>
                                                <li className="page-item active">
                                                    <a href="#" className="page-link">2</a>
                                                </li>
                                                <li className="page-item">
                                                    <a href="#" className="page-link">3</a>
                                                </li>
                                                <li className="page-item">
                                                    <a href="#" className="page-link">→</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="file-manager-detail-content minimal-border p-3 py-0" style={{ display: "block" }}>
                            <div className="mx-n3 pt-3 px-3 file-detail-content-scroll" data-simplebar>
                                <div id="folder-overview">
                                    <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed">
                                        <h5 className="flex-grow-1 fw-semibold mb-0">Overview</h5>
                                        <div>
                                            <button type="button" className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview">
                                                <i className="ri-close-fill align-bottom"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div id="simple_dount_chart d-block" data-colors='["--vz-info", "--vz-danger", "--vz-primary", "--vz-success"]' className="apex-charts mt-3" dir="ltr"></div>
                                    <div className="donut-chart">
                                        <Chart options={chartOptions} series={chartSeries} type="donut" width="300" />
                                    </div>
                                    <div className="mt-4">
                                        <ul className="list-unstyled vstack gap-4">
                                            <li>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0">
                                                        <div className="avatar-xs">
                                                            <div className="avatar-title rounded bg-secondary-subtle text-secondary">
                                                                <i className="ri-file-text-line fs-17"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h5 className="mb-1 fs-15">Documents</h5>
                                                        <p className="mb-0 fs-12 text-muted">2348 files</p>
                                                    </div>
                                                    <b>27.01 GB</b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0">
                                                        <div className="avatar-xs">
                                                            <div className="avatar-title rounded bg-success-subtle text-success">
                                                                <i className="ri-gallery-line fs-17"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h5 className="mb-1 fs-15">Media</h5>
                                                        <p className="mb-0 fs-12 text-muted">12480 files</p>
                                                    </div>
                                                    <b>20.87 GB</b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0">
                                                        <div className="avatar-xs">
                                                            <div className="avatar-title rounded bg-warning-subtle text-warning">
                                                                <i className="ri-folder-2-line fs-17"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h5 className="mb-1 fs-15">Projects</h5>
                                                        <p className="mb-0 fs-12 text-muted">349 files</p>
                                                    </div>
                                                    <b>4.10 GB</b>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0">
                                                        <div className="avatar-xs">
                                                            <div className="avatar-title rounded bg-primary-subtle text-primary">
                                                                <i className="ri-error-warning-line fs-17"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="flex-grow-1 ms-3">
                                                        <h5 className="mb-1 fs-15">Others</h5>
                                                        <p className="mb-0 fs-12 text-muted">9873 files</p>
                                                    </div>
                                                    <b>33.54 GB</b>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="pb-3 mt-auto">
                                        <div className="alert alert-danger d-flex align-items-center mb-0">
                                            <div className="flex-shrink-0">
                                                <i className="ri-cloud-line text-danger align-bottom display-5"></i>
                                            </div>
                                            <div className="flex-grow-1 ms-3">
                                                <h5 className="text-danger fs-14">Upgrade to Pro</h5>
                                                <p className="text-muted mb-2">Get more space for your...</p>
                                                <button className="btn btn-sm btn-danger"><i className="ri-upload-cloud-line align-bottom"></i> Upgrade Now</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div id="file-overview" className="h-100">
                                    <div className="d-flex h-100 flex-column">
                                        <div className="d-flex align-items-center pb-3 border-bottom border-bottom-dashed mb-3 gap-2">
                                            <h5 className="flex-grow-1 fw-semibold mb-0">File Preview</h5>
                                            <div>
                                                <button type="button" className="btn btn-ghost-primary btn-icon btn-sm fs-16 favourite-btn">
                                                    <i className="ri-star-fill align-bottom"></i>
                                                </button>
                                                <button type="button" className="btn btn-soft-danger btn-icon btn-sm fs-16 close-btn-overview">
                                                    <i className="ri-close-fill align-bottom"></i>
                                                </button>
                                            </div>
                                        </div>

                                        <div className="pb-3 border-bottom border-bottom-dashed mb-3">
                                            <div className="file-details-box bg-light p-3 text-center rounded-3 border border-light mb-3">
                                                <div className="display-4 file-icon">
                                                    <i className="ri-file-text-fill text-secondary"></i>
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-icon btn-sm btn-ghost-success float-end fs-16"><i className="ri-share-forward-line"></i></button>
                                            <h5 className="fs-16 mb-1 file-name">html.docx</h5>
                                            <p className="text-muted mb-0 fs-12"><span className="file-size">0.3 KB</span>, <span className="create-date">19 Apr, 2022</span></p>
                                        </div>
                                        <div>
                                            <h5 className="fs-12 text-uppercase text-muted mb-3">File Description :</h5>

                                            <div className="table-responsive">
                                                <table className="table table-borderless table-nowrap table-sm">
                                                    <tbody>
                                                        <tr>
                                                            <th scope="row" style={{ width: "35%" }}>File Name :</th>
                                                            <td className="file-name">html.docx</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">File Type :</th>
                                                            <td className="file-type">Documents</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Size :</th>
                                                            <td className="file-size">0.3 KB</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Created :</th>
                                                            <td className="create-date">19 Apr, 2022</td>
                                                        </tr>
                                                        <tr>
                                                            <th scope="row">Path :</th>
                                                            <td className="file-path"><div className="user-select-all text-truncate">*:\projects\src\assets\images</div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div>
                                                <h5 className="fs-12 text-uppercase text-muted mb-3">Share Information:</h5>
                                                <div className="table-responsive">
                                                    <table className="table table-borderless table-nowrap table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th scope="row" style={{ width: "35%" }}>Share Name :</th>
                                                                <td className="share-name">\\*\Projects</td>
                                                            </tr>
                                                            <tr>
                                                                <th scope="row">Share Path :</th>
                                                                <td className="share-path">velzon:\Documents\</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="mt-auto border-top border-top-dashed py-3">
                                            <div className="hstack gap-2">
                                                <button type="button" className="btn btn-soft-primary w-100"><i className="ri-download-2-line align-bottom me-1"></i> Download</button>
                                                <button type="button" className="btn btn-soft-danger w-100 remove-file-overview" data-remove-id="" data-bs-toggle="modal" data-bs-target="#removeFileItemModal"><i className="ri-close-fill align-bottom me-1"></i> Delete</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="modal fade zoomIn" id="createFolderModal" tabIndex={-1} aria-labelledby="createFolderModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        <div className="modal-header p-3 bg-success-subtle">
                            <h5 className="modal-title" id="createFolderModalLabel">Create Folder</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id="addFolderBtn-close" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form autoComplete="off" className="needs-validation createfolder-form" id="createfolder-form" noValidate>
                                <div className="mb-4">
                                    <label htmlFor="foldername-input" className="form-label">Folder Name</label>
                                    <input type="text" className="form-control" id="foldername-input" required placeholder="Enter folder name" />
                                    <div className="invalid-feedback">Please enter a folder name.</div>
                                    <input type="hidden" className="form-control" id="folderid-input" value="" placeholder="Enter folder name" />
                                </div>
                                <div className="hstack gap-2 justify-content-end">
                                    <button type="button" className="btn btn-ghost-success material-shadow-none" data-bs-dismiss="modal"><i className="ri-close-line align-bottom"></i> Close</button>
                                    <button type="submit" className="btn btn-primary" id="addNewFolder">Add Folder</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
           
            {/* {showCreateFileModal && ( */}
            <div className="modal fade" id="createFileModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content border-0">
                        <div className="modal-header p-3 bg-success-subtle">
                            <h5 className="modal-title" id="createFileModalLabel">Create File</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" id="addFileBtn-close" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            <form autoComplete="off" className="needs-validation createfile-form" id="createfile-form" noValidate>
                                <div className="mb-4">
                                    <label htmlFor="filename-input" className="form-label">File Name</label>
                                    <input type="text" className="form-control" id="filename-input" value="" required placeholder="Enter file name" />
                                    <div className="invalid-feedback">Please enter a file name.</div>
                                    <input type="hidden" className="form-control" id="fileid-input" value="" placeholder="Enter file name" />
                                </div>
                                <div className="hstack gap-2 justify-content-end">
                                    <button type="button" className="btn btn-ghost-success material-shadow-none" data-bs-dismiss="modal"><i className="ri-close-line align-bottom"></i> Close</button>
                                    <button type="submit" className="btn btn-primary" id="addNewFile">Create</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            {/* )}  */}

            <div id="removeFileItemModal" className="modal fade zoomIn" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-removefilemodal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2 text-center">                                
                                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                                    <h4>Are you sure ?</h4>
                                    <p className="text-muted mx-4 mb-0">Are you sure you want to remove this item ?</p>
                                </div>
                            </div>
                            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                                <button type="button" className="btn w-sm btn-light" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn w-sm btn-danger" id="remove-fileitem">Yes, Delete It!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <div id="removeFolderModal" className="modal fade zoomIn" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-removeFoldermodal"></button>
                        </div>
                        <div className="modal-body">
                            <div className="mt-2 text-center">
                                <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                                    <h4>Are you sure ?</h4>
                                    <p className="text-muted mx-4 mb-0">Are you sure you want to remove this folder ?</p>
                                </div>
                            </div>
                            <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
                                <button type="button" className="btn w-sm btn-light" data-bs-dismiss="modal">Close</button>
                                <button type="button" className="btn w-sm btn-danger" id="remove-folderList">Yes, Delete It!</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignageFileManager;
